export const CURRENCY_CONFIG = {
  CACHE_TTL: {
    CURRENCIES: 24 * 60 * 60 * 1000,
    EXCHANGE_RATES: 60 * 60 * 1000,
  },
} as const
